export const documentsBulkUploadConfig='documentBulkUpload';